import React, { memo } from 'react'
import { CircleCheckBig, Clock } from 'lucide-react';

import { COLORS, generateColors } from 'src/utils/colors';

import { JOB_STATUS } from 'src/constants';

type Props = {
  location: LocationType
  workerId?:string
  onSelectTask:(location:LocationType)=>void
}

const LocationCell: React.FC<Partial<Props>> = memo(({ location,onSelectTask }) => {

  const workerPlan = location?.worker_plans?.[0]

  const workerColor = workerPlan?.worker?.last_name?.[0] === 'X' ? 7 : workerPlan?.worker?.last_name?.[0] === 'Y' ? 3 : 5
  const dayOfWeek = workerPlan?.task_start_date && new Date(`${workerPlan?.task_start_date}`).getDay()
  const taskStatus= location?.worker_actuals?.[0]?.task_state
  const cellBgColor=dayOfWeek? COLORS[workerColor][generateColors(dayOfWeek)] : '' 
  const taskCell={...location!,color:cellBgColor}
  
  return (
    <div className=' border-gray-100 flex-1 w-[50px]' onClick={()=>onSelectTask?.(taskCell!)}
    style={{gridColumn:location?.widget_in_zone_row}}>
      <div className='flex flex-col justify-between items-center w-full h-[50px] p-2 border border-gray-100' style={{background: dayOfWeek? COLORS[workerColor][generateColors(dayOfWeek)] : '' }}>
        <div>
          <div> {workerPlan?.worker?.first_name &&(
        <div className='m-auto relative'>
        <div 
        className={`text-[10px] flex text-black items-center justify-center w-5 p-[0.5px] rounded-sm mx-auto ${taskStatus === JOB_STATUS.progress ? 'bg-orange-500' : taskStatus === JOB_STATUS.complete ? 'bg-white' : 'bg-transparent'}`}>
          <p>
            {`${workerPlan?.worker?.first_name?.[0] ?? ''}${workerPlan?.worker?.last_name?.[0] ?? ''}`}
          </p>
          
        </div>
        <div className='absolute bottom-0 right-0 mr-[-12px]'>
       {taskStatus === JOB_STATUS.progress?  <Clock size={10} className='text-orange-500 bg-white rounded-full'/>:taskStatus === JOB_STATUS.complete ?<CircleCheckBig size={10} className='text-green-700 bg-white rounded-full'/>:null } 
        </div>
     </div>)}
        </div>
        </div>
       <div>
       <p style={{ fontSize: 8 }}>
         {location?.location_moniker }    
        </p>
       </div>
      </div>
    </div>
  )
})

export default LocationCell